module.exports = __webpack_public_path__ + "8ef7d4d1561cbe62f782f7a56956a470.jpg";